import { SvgIcon } from "@mui/material";

interface IGithubProps {
  color?: string;
  className?: string;
}

const Github: React.FC<IGithubProps> = (props) => {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.875 0C11.2991 0 9.73871 0.318095 8.2828 0.936124C6.82689 1.55415 5.50402 2.46001 4.38972 3.60198C2.13928 5.90829 0.875 9.03631 0.875 12.2979C0.875 17.7336 4.319 22.3453 9.083 23.981C9.683 24.0793 9.875 23.6981 9.875 23.3661V21.2877C6.551 22.0256 5.843 19.6398 5.843 19.6398C5.291 18.2132 4.511 17.832 4.511 17.832C3.419 17.0695 4.595 17.0941 4.595 17.0941C5.795 17.1802 6.431 18.3608 6.431 18.3608C7.475 20.2301 9.239 19.6767 9.923 19.3815C10.031 18.5822 10.343 18.0411 10.679 17.7336C8.015 17.4262 5.219 16.3685 5.219 11.683C5.219 10.318 5.675 9.22344 6.455 8.35029C6.335 8.04284 5.915 6.76386 6.575 5.10364C6.575 5.10364 7.583 4.77159 9.875 6.35803C10.823 6.08747 11.855 5.9522 12.875 5.9522C13.895 5.9522 14.927 6.08747 15.875 6.35803C18.167 4.77159 19.175 5.10364 19.175 5.10364C19.835 6.76386 19.415 8.04284 19.295 8.35029C20.075 9.22344 20.531 10.318 20.531 11.683C20.531 16.3808 17.723 17.4139 15.047 17.7213C15.479 18.1025 15.875 18.8527 15.875 19.9964V23.3661C15.875 23.6981 16.067 24.0916 16.679 23.981C21.443 22.333 24.875 17.7336 24.875 12.2979C24.875 10.6829 24.5646 9.08376 23.9616 7.59171C23.3585 6.09966 22.4746 4.74395 21.3603 3.60198C20.246 2.46001 18.9231 1.55415 17.4672 0.936124C16.0113 0.318095 14.4509 0 12.875 0Z"
        fill={props.color || "black"}
      />
    </SvgIcon>
  );
};

export default Github;
